module.exports = __webpack_public_path__ + "static/media/spin.997e0b6f.svg";